// extracted by mini-css-extract-plugin
export default {"boxWrapper":"AutomatedMessaging--boxWrapper--7de970","headerBox":"AutomatedMessaging--headerBox--c51bf5"};